import { Link } from 'react-router-dom'
import TermsModal from './modals/TermsModal'
import ErrorMessage from "./errors/ErrorMessage";

export default function Terms(props) {
  return (
    <div>
      <div className="flex items-center justify-between">
        <div className="flex items-start -mb-4">
          <div className="flex items-center h-5">
            {props.color ? (
              //bg-${partner}-primary
              <input id="remember" name={props.name} checked={props.value} onChange={props.handleInputChange(props.name)} aria-describedby="remember" type="checkbox" style = {{color: props.color}} className={`w-4 h-4 bg-grey-700 bg-gray-100 border-gray-300 rounded focus:ring-2`} required=""></input>
            ) : (
              <input id="remember" name={props.name} checked={props.value} onChange={props.handleInputChange(props.name)} aria-describedby="remember" type="checkbox" className="w-4 h-4 bg-grey-700 text-primary-200 bg-gray-100 border-gray-300 rounded focus:ring-primary-200 focus:ring-2" required=""></input>
            )}
          </div>
          <div className="ml-3 text-sm">
            <label htmlFor="remember" className="text-gray-700">
              I agree to the </label>
            <span className="cursor-pointer"><TermsModal color = {props.color}></TermsModal></span>
          </div>
        </div>
      </div>
      {props.error ? (
        <div className="mt-8">
          <ErrorMessage message={props.message}></ErrorMessage>
        </div>
      ) : (
        ""
      )}
    </div>

  )
}